"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("../Sidebar/styles");

var styles = function styles(theme) {
  var _internal;

  if (!("scrollbars" in theme)) {
    theme.scrollbars = {
      main: {}
    };
  }

  return {
    root: {
      display: "flex",
      flexDirection: "row"
    },
    logo: {
      width: "".concat(_styles.mainPanelWidth, "px")
    },
    internal: (_internal = {
      borderTop: "0px solid " + theme.palette.primary.main,
      transition: theme.transitions.create(["border-top", "height"], {
        duration: theme.transitions.duration.complex,
        delay: theme.transitions.duration.standard
      }),
      height: theme.mixins.toolbar.minHeight + theme.spacing(3.5)
    }, (0, _defineProperty2.default)(_internal, theme.breakpoints.down("sm"), {
      borderTop: "4px solid " + theme.palette.primary.main
    }), (0, _defineProperty2.default)(_internal, theme.breakpoints.down("xs"), {
      height: theme.mixins.toolbar.minHeight
    }), _internal),
    toolbar: (0, _defineProperty2.default)({}, theme.breakpoints.up("md"), {
      marginLeft: "".concat(_styles.mainPanelWidth, "px")
    }),
    left: {
      paddingRight: "1em"
    },
    right: {
      paddingLeft: "1em",
      flexShrink: 0
    },
    middle: {
      flexGrow: 1,
      display: "flex"
    },
    displayName: {
      fontSize: "1rem"
    }
  };
};

exports.styles = styles;